<template>
  <div class="card" @click="go">
    <div class="header">
      <div class="info">
        <div class="visitor">{{ name }}</div>
        <p>{{ why }}</p>
      </div>
      <div v-show="stateMSG" class="edit-icon" @click.stop="toEdit">
        <img src="@/assets/images/edit-square.svg" alt="" />
      </div>
      <div @click.stop="openDoor" v-if="!openTest && openBox">
        <van-button
          round
          block
          type="info"
          v-show="openBox"
          native-type="submit"
          class="open"
          @click.stop="openDoor1"
          :style="{
            background: openTest ? '#009BFF' : '#F9F9F9',
            borderColor: openTest ? '#009BFF' : '#D9D9D9',
            color: openTest ? '#FFFFFF' : '#565656',
          }"
          :disabled="openTest"
        >
          {{ openBox }}
        </van-button>
      </div>
    </div>
    <div class="time">{{ time }}</div>
    <div class="company" v-show="company">{{ company }}</div>
    <div v-show="stateMSG" class="state" @click.stop="cancelIt">
      {{ stateMSG }}
    </div>
    <div v-show="showEarlyEnd" class="state" @click.stop="handleEarlyEnd">提前结束</div>
    <div class="operation" v-if="approval === 1">
      <div @click.stop="repeat" class="editDestine">{{ $t('同意') }}</div>
      <div @click.stop="refuse" class="rejectDestine">{{ $t('拒绝') }}</div>
    </div>
    <div class="operation" v-if="approval === 2">
      <p>{{ $t('待 ') }}{{ auditName }}{{ $t(' 审批') }}</p>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import Vue from 'vue'
import { Button } from 'vant'
Vue.use(Button)
export default {
  name: 'Card',
  props: [
    'visitorName',
    'purpose',
    'visitorState',
    'open',
    'visitorTime',
    'companyName',
    'click',
    'cancel',
    'visitorId',
    'registerTime',
    'clickOpen',
    'registerRobot',
    'visitTime',
    'visitEndTime',
    'stateMSG',
    'isApproval',
    'checkRepeat',
    'onRefuse',
    'auditStaffName',
    'onEarlyEnd',
    'finishTime',
  ],

  data() {
    return {
      name: this.visitorName,
      why: this.purpose,
      state: this.visitorState,
      openBox: this.open,
      time: this.visitorTime,
      company: this.companyName,
      id: this.visitorId,
      hostId: '',
      deviceId: '',
      approval: this.isApproval,
      auditName: this.auditStaffName,
    }
  },
  computed: {
    openTest() {
      if (
        dayjs().valueOf() > dayjs(this.visitTime).valueOf() &&
        dayjs().valueOf() < dayjs(this.visitEndTime).valueOf()
      ) {
        return false
      } else {
        return true
      }
    },
    // 是否显示提前结束按钮
    showEarlyEnd() {
      // 如果已经提前结束了，不显示
      if (this.finishTime) {
        return false
      }

      const now = dayjs()
      const start = dayjs(this.visitTime)
      const end = dayjs(this.visitEndTime)

      // 当前时间大于开始时间且小于结束时间，显示提前结束按钮
      return now.isAfter(start) && now.isBefore(end)
    },
  },
  methods: {
    go() {
      if (this.click) this.click(this.id)
    },
    cancelIt() {
      if (this.cancel) this.cancel(this.id)
    },
    openDoor() {
      return
    },
    toEdit() {
      this.$router.push({
        path: 'NewInvitation',
        query: { visitorId: this.id },
      })
    },
    openDoor1() {
      if (this.clickOpen) this.clickOpen(this.registerRobot)
    },
    repeat() {
      if (this.checkRepeat) {
        this.checkRepeat({ id: this.$props.visitorId, opinion: 'agree' })
      }
    },
    refuse() {
      if (this.onRefuse) {
        this.onRefuse({ id: this.$props.visitorId, opinion: 'refuse' })
      }
    },
    handleEarlyEnd() {
      if (this.onEarlyEnd) {
        this.onEarlyEnd(this.id)
      }
    },
  },
}
</script>
<style lang="less" scoped>
.card {
  width: 351px;
  min-height: 110px;
  height: auto;
  background: #fefffe;
  border-radius: 8px;
  padding: 12px 20px 16px;
  font-size: 14px;
  color: #666666;
  .header {
    display: flex;
    justify-content: space-between;
    height: 24px;
    line-height: 24px;
    .info {
      display: flex;
      align-items: center;
    }
    .visitor {
      max-width: 170px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #1e2329;
      line-height: 24px;
      text-align: left;
      font-style: normal;

      margin-right: 15px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
    p {
      height: 18px;
      line-height: 18px;
      background: #ffe4c4;
      padding: 0 4px;
      border-radius: 2px;
      color: #ac7a3c;
      font-size: 12px;
    }
    .edit-icon {
      img {
        height: 24px;
        width: 24px;
      }
    }
    .open {
      width: 64px;
      height: 28px;
    }
    /deep/.van-button--normal {
      padding: 0;
      font-size: 13px;
    }
  }
  .time,
  .company {
    min-height: 24px;
    line-height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #474d57;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    margin-top: 2px;
  }
  .state {
    width: 60px;
    margin-top: 12px;
    color: #3972ff;
    line-height: 16px;
  }
  .operation {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 12px;
    p {
      color: #1e2329;
    }
    .editDestine {
      width: auto;
      height: 22px;
      color: #3972ff;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      margin-right: 36px;
    }
    .rejectDestine {
      width: auto;
      height: 22px;

      border-radius: 15px;
      color: #f6465d;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      text-align: left;
      font-style: normal;
    }
    .orderDestine {
      width: 80px;
      height: 28px;
      background: #009bff;
      border-radius: 24px;
      color: #ffffff;
      font-size: 13px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .notify {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 120px;
      height: 28px;
      border-radius: 24px;
      background: #009bff;
      color: #ffffff;
      font-size: 13px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }
    .meeting {
      color: #009bff;
      font-size: 14px;
      line-height: 28px;
    }
  }
}
</style>
